import React from "react";
import { useAtom } from "jotai";

import { BrowserRouter as Router } from "react-router-dom";
import ProtectedApp from "./utils/protectedApp";
import "primereact/resources/themes/lara-light-blue/theme.css"; // modern theme
import "primeflex/primeflex.css"; // css utility
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import { BlockUI } from "primereact/blockui";

import { loadingState } from "./states/loadingState";

import ToastGlobal from "./components/toastGlobal";

const App = () => {
  const [isLoading] = useAtom(loadingState);

  return (
    <Router>
      <ToastGlobal />
      <BlockUI blocked={isLoading} fullScreen>
        <ProtectedApp />
      </BlockUI>
    </Router>
  );
};

export default App;
